import React from 'react';
import { priceFormat } from '@/utils/common';
import { renderCouponLabel } from '../renderCouponLabel';
import { renderSecKillCountDown } from '../renderSecKillCountDown';
import { processDescText } from '../../utils';
import './index.less';
import { GoodsItem } from '@/pages/charge-vip/types';

export interface FillGoodsItemProps {
  goodItem: GoodsItem;
  active: GoodsItem | null;
  activeChange: (item: GoodsItem, index: number) => void;
  index: number;
  isSeckill: boolean;
  countdown: string;
}

export const FillGoodsItem: React.FC<FillGoodsItemProps> = ({
  goodItem,
  active,
  activeChange,
  index,
  isSeckill,
  countdown,
}) => {
  const isActive = goodItem?.skuId === active?.skuId;
  return (
    <div
      className={`good-item
        fill-good-item
        ${isActive ? 'active' : ''}
      `}
      onClick={() => activeChange(goodItem, index)}
      key={`good-${goodItem?.skuId}-${index}`}
    >
      {renderCouponLabel({
        couponLabel: goodItem?.actDiscountLabel,
        discountType: goodItem?.discountType,
        countdown,
      })}
      <div className="good-fill-content">
        <div className="good-fill-item">
          <div className="good-title-wrap fill-good-item">
            {goodItem?.name || '--'}
          </div>
          <div className="good-extra-wrap fill-good-item">
            {processDescText(goodItem?.desc).map((line: string, idx: number, array) => (
              <React.Fragment key={idx}>
                {line}
                {idx < array.length - 1 && <br />}
              </React.Fragment>
            ))}
          </div>
        </div>
        <div
          className="good-price-wrap"
          style={{
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 0,
          }}
        >
          <div className="good-price">
            <div className="big-heavy-text-unit">¥</div>
            <div className="big-heavy-text">
              {priceFormat(
                goodItem?.discountType !== 'ORIGINAL_PRICE'
                  ? goodItem?.discountBuyPrice
                  : goodItem?.salePrice,
              )}
            </div>
          </div>
        </div>
      </div>
      {renderSecKillCountDown({
        countdown,
        isSeckill,
      })}
    </div>
  );
};